import { utils } from '@sfaas/util';

export default {
	taskId_: state => {
		const { taskId } = state.searchParams;
		return taskId;
	},

	urlSearchParams_: state => {
		const { searchParams, pagingInfo } = state;
		const urlSearchParams = new URLSearchParams();
		Object.keys(searchParams).forEach(key => {
			const value = searchParams[key];
			if (!utils.$sf_isNull(value) && !value.includes('ALL')) {
				urlSearchParams.set(key, value);
			}
		});
		// TODO
		Object.keys(pagingInfo).forEach(key => {
			const validKeys = ['currentPage', 'pageUnit'];
			const value = pagingInfo[key];
			if (validKeys.includes(key)) {
				urlSearchParams.set(key, value);
			}
		});
		return urlSearchParams.toString();
	},

	totalSize_: state => {
		const { pagingInfo } = state;
		const { totalSize } = pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pagingInfo } = state;
		const { pageUnit } = pagingInfo;
		return pageUnit;
	}
};
